// Modal.tsx
import React, { FC, ReactNode } from 'react'
import { createPortal } from 'react-dom'
import './style.scss'

type ModalProps = {
  isOpen: boolean
  borderColor?: boolean
  onClose: () => void
  children: ReactNode
  styleContainer?: React.CSSProperties
  styleContainerContent?: React.CSSProperties
  styleClose?: React.CSSProperties
}

const Modal: FC<ModalProps> = ({
  isOpen,
  borderColor = false,
  styleContainerContent,
  onClose,
  children,
  styleContainer,
  styleClose
}) => {
  return isOpen
    ? createPortal(
        <div className={`modal-overlay `}>
          <div style={styleContainer} className={`modal `}>
            <div
              style={styleContainerContent}
              className={`content ${borderColor ? 'borderAnimateIpass borderModal' : ''}`}
            >
              <div className={`subContent  ${borderColor ? 'inner' : ''}`}>{children}</div>
            </div>
            <button className="close-button" onClick={onClose} style={styleClose}>
              X
            </button>
          </div>
        </div>,
        document.body
      )
    : null
}

export default Modal
